<template>
  <div class="inline-navigation-btns-container" v-if="$isMobile()">
    <div class="inline-next-page-button inline-nav-page-button-container" v-if="Next">
      <span class="inline-next-image inline-nav-image" alt="next-image" @click="GoNext">
        <span class="inline-nav-text">{{Next}}</span>
        <i class="fas fa-chevron-right"></i>
      </span>
    </div>

    <div class="inline-previous-page-button inline-nav-page-button-container" v-if="Back">
      <span class="inline-previous-image inline-nav-image" alt="previous-image" @click="GoBack">
        <i class="fas fa-chevron-left"></i>
        <span class="inline-nav-text">{{Back}}</span>
      </span>
    </div>
  </div>
</template>

<script>
import common from "../mixins/CommonFunctions";

export default {
  mixins: [common],
  props: ["Next", "Back"],
  data: function () {
    return {};
  },
  methods: {},
};
</script>

<style>
.inline-nav-image {
  position: relative;
  height: 66px;
  padding: 20px;
  border: 0px solid white;
  margin: auto;
  margin-top: 30px;
  cursor: pointer;
  z-index: 999999;
  -webkit-transition: color 0.5s;
  -o-transition: color 0.5s;
  transition: color 0.5s;
  font-size: 11px;
  color: #aacbec !important;
}

.inline-next-image .inline-nav-text {
  margin-right: 10px;
}

.inline-previous-image .inline-nav-text {
  margin-left: 10px;
}

.inline-next-page-button .inline-next-image {
  float: right;
}
.inline-nav-image i {
  cursor: pointer;
  color: #aacbec !important;
}

.inline-previous-page-button .inline-previous-image {
  float: left;
}

.hidden {
  display: none;
}
</style>